import { VideoOData } from '@bingads-webui-campaign/video-odata';

export class VideoRepository {
  constructor(
    cid,
    aid,
    oDataConfig,
    activityLogger
  ) {
    this.videoOData = new VideoOData(cid, aid, oDataConfig, activityLogger);
  }

  getUploadUrl({ fileExtension }) {
    return this.videoOData.getUploadUrl({ fileExtension });
  }

  getUploadUrlForRepair({ fileExtension, id }) {
    return this.videoOData.getUploadUrlForRepair({ fileExtension, id });
  }

  postVideoByFile({
    file, description, onProgress,
  }) {
    return this.videoOData.postVideoByFile({ file, description, onProgress });
  }

  postVideoByUrl({ videoUrl }) {
    return this.videoOData.postVideoByUrl({ videoUrl });
  }

  getVideos({
    sortById,
    searchTerm,
    pageNumber,
    pageSize,
  }) {
    return this.videoOData.getVideos({ sortById, searchTerm, pageNumber, pageSize });
  }

  replaceVideoByUrl({ videoUrl, id }) {
    return this.videoOData.replaceVideoByUrl({ videoUrl, id });
  }

  replaceVideoBySelectingVideo({ videoUrl, id, description }) {
    return this.videoOData.replaceVideoBySelectingVideo({ videoUrl, id, description });
  }

  replaceVideoByBlob({ id, file, onProgress }) {
    return this.videoOData.replaceVideoByBlob({ id, file, onProgress });
  }

  getVideo({ id }) {
    return this.videoOData.getVideo({ id });
  }

  patchVideo({ id, deltaVideo }) {
    return this.videoOData.patchVideo({ id, deltaVideo });
  }

  deleteVideo({ id }) {
    return this.videoOData.deleteVideo({ id });
  }

  /* istanbul ignore next */
  createVideoBasedOnOriginalVideo({ id, data }) {
    return this.videoOData.createVideoBasedOnOriginalVideo({ id, data });
  }
}
